<template>
  <div class="policy_detail" :style="{paddingBottom: isOneClickRenewal == 'Y' ? '100px' : '60px'}">
   <div class="policy_box">
     <!-- 保单信息 -->
     <div class="pro_info">
       <div class="pro_name">
         <p class="title_">{{productName}}</p>
         <p class="return_">{{viewStateDesc}}</p>
       </div>
       <p class="pro_item">
         <span>订单号：</span>
         <span>{{policyId || '-'}}</span>
       </p>
       <p class="pro_item">
         <span>保单起期：</span>
         <span>{{policyInfo.effectiveDate || '-'}}</span>
       </p>
       <p class="pro_item">
         <span>保单止期：</span>
         <span>{{policyInfo.expireDate || '-'}}</span>
       </p>
       <p class="pro_item">
         <span>等待期：</span>
         <span>{{policyInfo.waitDay ? policyInfo.waitDay + '天' : '-'}}</span>
       </p>
       <p class="pro_item">
         <span>保障额度：</span>
         <span>{{policyInfo.coverageAmount ? policyInfo.coverageAmount + '元' : '-'}}</span>
       </p>
       <p class="pro_item">
         <span>交费年限：</span>
         <span>{{policyInfo.payendyear ? policyInfo.payendyear + '年': '-'}}</span>
       </p>
       <p class="pro_item">
         <span>犹豫期：</span>
         <span>{{policyInfo.hesitationDays ? policyInfo.hesitationDays + '天' : '-'}}</span>
       </p>
       <p class="pro_item">
         <span>保障年限：</span>
         <span>{{policyInfo.guaranteePeriod ? policyInfo.guaranteePeriod : '-'}}</span>
       </p>
       <p class="pro_item">
          <span>保单状态：</span>
          <span>{{status | filterStatus}}</span>
          <a class="download-file" v-if="status&&(status.indexOf('问题件') >-1 ||status == '6')>-1&&questionList && questionList.length==1" :href="questionList[0].url" :download="questionList[0].fileName">{{questionList[0].fileName}}</a>
          <span class="download-btn" v-if="status&&(status.indexOf('问题件') > -1 ||status == '6')&&questionList && questionList.length > 1" @click="showQuestionList=true">问题件下载</span>
       </p>
       <p class="pro_item">
         <span>首次保费：</span>
         <span>{{policyInfo.totalPremium ? policyInfo.totalPremium + '元' : '-'}}</span>
       </p>
     </div>
     <!-- 投保人信息 -->
     <div class="pro_info">
       <div class="pro_name">
         <p class="title_">投保人信息：</p>
       </div>
       <p class="pro_item">
         <span>姓名：</span>
         <span>{{policyHolder.name || '-'}}</span>
       </p>
       <p class="pro_item">
         <span>证件类型：</span>
         <span>{{policyHolder.idType | filterIdType}}</span>
       </p>
       <p class="pro_item">
         <span>证件号：</span>
         <span>{{policyHolder.idNumber || '-'}}</span>
       </p>
       <p class="pro_item">
         <span>手机号：</span>
         <span>{{policyHolder.telephone || '-'}}</span>
       </p>
       <p class="pro_item">
         <span>邮箱：</span>
         <span>{{policyHolder.email || '-'}}</span>
       </p>
       <p class="pro_item">
         <span>地址：</span>
         <span>{{policyHolder.address || '-'}}</span>
       </p>
     </div>
     <!-- 被保险人信息 -->
     <div class="pro_info">
       <div class="pro_name" @click="isShowInsureds = !isShowInsureds">
         <p class="title_">被保险人信息：</p>
         <img src="../../../assets/image/nsale/down.png" alt="" style="width: 8px;height: 5px;">
       </div>
       <template v-if="isShowInsureds">
        <div class="insured_" v-for="(item,index) in insureds" :key="index">
          <p class="pro_item">
            <span>姓名：</span>
            <span>{{item.name || '-'}}</span>
          </p>
          <p class="pro_item">
            <span>证件类型：</span>
            <span>{{item.idType | filterIdType}}</span>
          </p>
          <p class="pro_item">
            <span>证件号：</span>
            <span>{{item.idNumber || '-'}}</span>
          </p>
          <p class="pro_item">
            <span>性别：</span>
            <span>{{item.gender == 'M' ? '男' : item.gender ? '女' : '-'}}</span>
          </p>
        </div>
       </template>
     </div>
     <!-- 受益人信息 -->
     <div class="pro_info">
       <div class="pro_name">
         <p class="title_">保险金受益人：</p>
       </div>
       <p class="pro_item">
         <span>受益人：</span>
         <span>{{beneficiariesDesc}}</span>
       </p>
     </div>
   </div>
   <div class="show_policy">
     <a class="link_" v-if="policyInfo.electronicInsurance!='N'" :href="policyInfo.epolicyUrl">查看电子保单</a>
   </div>
   <div class="bottom_">
     <div class="one_click_renewal" v-if="isOneClickRenewal == 'Y'" @click="oneClickRenewal">
      一键续保
    </div>
    <div class="foot_">
      <p>全部产品获取</p>
      <p>请用电脑360浏览器登录https://nyboss.ssish.com/</p>
    </div>
   </div>
    <!-- 问题件下载 -->
    <div class="mask" v-if="showQuestionList" @click.self="showQuestionList=false">
        <div class="renewal-guide">
            <h3 class="pro-title">问题件下载</h3>
            <p class="close_" @click="showQuestionList=false">x</p>
            <div class="scroll-box">
                <a v-for="(item, index) in questionList" :key="index" :href="item.url" :download="item.fileName">{{item.fileName}}</a>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
import api from "@/utils/api";
import filters from "@/utils/filters";
export default {
  data() {
    document.title = '订单详情'
    return {
      viewStateDesc: '',
      showQuestionList: false, // 问题件下载弹框
      questionList: [], // 问题件列表
      detailInfo: {},
      policyInfo: {},
      insureds: [],
      policyHolder: {},
      beneficiariesDesc: '', // 受益人
      policyId: '',
      isShowInsureds: false,
      status: '',
      isOneClickRenewal: '',
      productName: ''
    }
  },
  methods: {
  // 查询问题件列表
    getQuestionList(policyId) {
      api.questionList({policyId}).then((res) => {
          console.log(res)
          let { returnCode, returnMsg, content } = res.data;
          if(returnCode != '0000') {
          this.$toast(returnMsg);
          return;
          }
          this.questionList = content
      })
    },
    getPolicyInfo(policyId) {
      api.getPolicyInfo(policyId).then(res => {
        this.detailInfo = res.data.content
        this.policyInfo = this.detailInfo.policyInfo
        if(this.policyInfo.status.indexOf('问题件') > -1 || this.policyInfo.status == '6') {
            this.getQuestionList(this.policyInfo.id);
        } 
        this.insureds = this.detailInfo.insureds
        this.policyHolder = this.detailInfo.policyHolder
        this.beneficiariesDesc = this.detailInfo.beneficiariesDesc
      })
    },
    // 一键续保
    oneClickRenewal() {
      let params = {
        policyId: this.policyInfo.id,
        productCode: this.policyInfo.productCode
      }
      api.getRenewalUrl(params).then(res => {
        window.location.href = res.data.content
      })
    },
  },
  filters: {
    ...filters,
    filterStatus(val) {
      console.log(val, 206)
      if (val == '14' || val == '15') {
        return '核保失败'
      } else if (val == '-2') {
        return '待完善'
      } else if (val == '11' || val == '32') {
        return '核保中'
      } else if (val == '0' || val == '17') {
        return '待支付'
      } else if (val == '3') {
        return '已支付投保失败'
      } else if (val == '4') {
        return '拒保延期'
      } else if (val == '5') {
        return '待复核'
      } else if (val == '6') {
        return '问题件'
      }
    }
  },
  mounted() {
    let { policyId,status,isOneClickRenewal,productName } = this.$route.query
    this.policyId = policyId
    this.status = status
    this.isOneClickRenewal = isOneClickRenewal
    this.productName = productName
    this.getPolicyInfo(this.policyId)
  }
}
</script>
<style lang="scss" scoped>
.policy_detail {
  padding: 20px 20px 100px;
  background: #F9F9F9;
  border-radius: 7px;
  .mask {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.45);
    font-size: 12px;
    .renewal-guide {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100vw;
    height: 40%;
    background: #fff;
    border-radius: 20px 20px 0 0;
    padding: 20px;
    box-sizing: border-box;
    }
    .pro-title {
    font-size: 13px;
    color: #373737;
    font-weight: bold;
    margin-bottom: 14px;
    }
    .close_ {
    position: absolute;
    right: 20px;
    top: 20px;
    color: #000;
    font-size: 16px;
    text-align: right;
    }
    .scroll-box {
        max-height: 80%;
        overflow: auto;
        padding: 10px;
          a {
            display: block;
            color:#5599FF;
            text-decoration: underline;
            line-height: 2.2;
            text-align: left;
        }
    }
}
  .policy_box {
    width: 100%;
    background: #fff;
    .title_ {
      font-weight: 600;
      color: #333333;
      line-height: 21px;
      font-size: 15px;
    }
    .pro_info {
      margin: 0 17px;
      padding: 15px 0;
      border-bottom: 1px solid #ECECEC;
      &:last-child {
        border-bottom: 0;
      }
      .pro_name {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
        .return_ {
          color: #FF7C6D;
          font-size: 13px;
        }
      }
      .pro_item {
        font-size: 12px;
        color: #666666;
        text-align: left;
        height: 17px;
        line-height: 17px;
        margin-bottom: 4px;
        .download-file {
          color: #5599FF; 
          text-decoration: underline;
          margin-left: 10px;
          max-width: 50%;
        }
        .download-btn {
          color: #5599FF; 
          margin-left: 10px;
        }
      }
    }
    .insured_ {
      // margin-bottom: 20px;
    }
  }
  .show_policy {
    text-align: left;
    .link_ {
      color: #5599FF;
      font-size: 12px;
      margin: 12px 0 12px 16px;
    }
  }
  .bottom_ {
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    padding: 0 20px;
    background: #f9f9f9;
    .one_click_renewal {
      background: linear-gradient(45deg, #FF7C6C 0%, #FFA297 100%);
      color: #fff;
      font-size: 16px;
      height: 35px;
      line-height: 35px;
      border-radius: 8px;
      margin-top: 10px;
    }
    .foot_ {
      p {
        font-size: 11px;
        color: #CACACA;
        line-height: 15px;
      }
      margin: 12px 0;
    }
  }
 
}
</style>

